window.app = window.app || {};

jQuery(function($) {

    window.app.perform3dsCybersourceAuth = function(formHelperRequest, config) {

        formHelperRequest.$form.addClass('cybersource-3ds-active');
        formHelperRequest.disableControls();

        var options = {
            ajaxURLs: config.ajaxURLs,
            flexResponseJSON: formHelperRequest.data.flexResponseJSON,
            cardinal3DSJWT: formHelperRequest.data.accessToken,
            cardinalSessionId: formHelperRequest.data.referenceId
        };

        var newCybersource3ds = new Cybersource3ds(options);

        newCybersource3ds.initiateDDC(formHelperRequest.data.deviceDataCollectionUrl).then(function(ddcStatus) {

            var includeManualBrowserFields = false;

            if (ddcStatus === 'ddc_failed') {
                includeManualBrowserFields = true;
            }

            newCybersource3ds.performCyberSourceAuth(formHelperRequest, includeManualBrowserFields, window.app.process3dsStatus);
        })
    }

    window.app.process3dsStatus = function(formHelperRequest, status) {

        console.log(status);

        formHelperRequest.$form.removeClass('cybersource-3ds-active');
        formHelperRequest.enableControls();

        switch (status) {

            case 'VALIDATION_SUCCESS':
                formHelperRequest.$form.data('cybersource-3ds-success-submit', true);
                formHelperRequest.$form.submit();
                break;

            case 'VALIDATION_FAILURE':
            case 'SERVICE_TIME_OUT':
            case 'DATA_RESPONSE_ERROR':

                var msgLocalizedForJSLabel = 'Cybersource3DS_' + status;
                var p = $('<p>').text(localizedForJS[msgLocalizedForJSLabel].unescapeHTML())[0];
                toggleBlanket('alert',p,'');
                formHelperRequest.$form.removeClass('cybersource-3ds-active');
                formHelperRequest.enableControls();
                break;
        }
    }
});

(function($) {

	formHelper.addIPeerRule({

		iframe_custom_event_handler: function(payload){
			// this is where we might look at the payload and do differnt
			// things depending on what message we got from the iframe
			// But in 99% of the cases, there is probably only 1 reason
			// for a custom event handler... showing the CVV dialog
			// so ignore the payload
			var event = payload.event;
			switch (event) {
				case "whatisthis":
					toggleCIDHelper();
					break;
				case "cardtypechange":
					// set hidden to payload value
					$('#card-type-amex').val(payload.usingAMEX);
					break;
				case "outstandingchargetotalchange":
					// set hidden to payload value
					$('#outstanding-charge-total').val(payload.outstandingtotal);
					break;
			}
		}
	});

	window.app.promoCodeFieldEmpty = function() {
		var promoCode = $.trim($("#promoCode").val());
		if (promoCode.length > 0) {
			var para = new Element('p');
			para.update(localizedForJS.pleaseSubmitPromoCode);
			toggleBlanket('alert',para,'');
			return false;
		}
		else {
			 return true;
		}
	}

})(jQuery);

jQuery(function($) {

    $(document).on('click','.js-whatisthis',function(event) {

        event.preventDefault();
        toggleCIDHelper();
    });

	$(document).on('change','.js-billing-country',function(event) {

		var billingCountry = $(this).val();

		var cpfContainer = $('.js-cpf-container');
		if (billingCountry === 'Brazil' ) {
			cpfContainer.find('.label').addClass('required');
			cpfContainer.find('.js-cpf').prop('disabled',false);
			cpfContainer.show();
		}
		else {
			cpfContainer.find('.label').removeClass('required');
			cpfContainer.find('.js-cpf').val('').prop('disabled',true);
			cpfContainer.hide();
		}

		var cuitContainer = $('.js-cuit-container');
		if (billingCountry === 'Argentina' ) {
			cuitContainer.find('.label').addClass('required');
			cuitContainer.find('.js-cuit').prop('disabled',false);
			cuitContainer.show();
		}
		else {
			cuitContainer.find('.label').removeClass('required');
			cuitContainer.find('.js-cuit').val('').prop('disabled',true);
			cuitContainer.hide();
		}

		var nitContainer = $('.js-nit-container');
		if (billingCountry === 'Colombia' ) {
			nitContainer.find('.label').addClass('required');
			nitContainer.find('.js-nit').prop('disabled',false);
			nitContainer.show();
		}
		else {
			nitContainer.find('.label').removeClass('required');
			nitContainer.find('.js-nit').val('').prop('disabled',true);
			nitContainer.hide();
		}

		event.preventDefault();
		if (formHelper.portholeSendFHIPeerCustomEvent) {
			formHelper.portholeSendFHIPeerCustomEvent({"event":"bcountrychange","billingcountry":$(this).val()});
		}
	});

});

jQuery(function($){

	$(document).on('change','.js-traveler-country',function(event){
		event.preventDefault();
		if (formHelper.portholeSendFHIPeerCustomEvent) {
			formHelper.portholeSendFHIPeerCustomEvent({"event":"countrychange","travelercountry":$(this).val()});
		}
	});

});

jQuery(function($) {

	$(document.body).on('click', '.js-toggle-password-display', function() {

		var $clickedOnToggle = $(this);
		var toggleType       = $clickedOnToggle.data('password-display');
		var $formField       = $clickedOnToggle.closest('.formfield, .formField');
		var $passwordInput   = $formField.find('.js-toggle-password-input');

		if (toggleType === 'show') {

			$clickedOnToggle.data('password-display','hide');
			$clickedOnToggle.addClass('fa-eye-slash');
			$passwordInput.attr('type','text');
		}
		else {

			$clickedOnToggle.data('password-display','show');
			$clickedOnToggle.removeClass('fa-eye-slash');
			$passwordInput.attr('type','password');
		}

	});
});

jQuery(function($) {

	var isTransitioning = false;

	// **************************************************************************************************************
	// Load More Inventory Secondary Control
	// **************************************************************************************************************
	$('.js-load-availability-controls').click(function(e) {
		if (!isTransitioning) {
			isTransitioning = true;
			toggleLoadAvailability('load');
		}
	});

	// **************************************************************************************************************
	// FUNCTION:    toggleLoadAvailability
	// PARAMETERS:  type (the toggle type associated with the availability loader scenario)
	// DESCRIPTION: This function handles displaying and resetting hidden availability items
	// **************************************************************************************************************
	var toggleLoadAvailability = function(type) {

		if (type === 'load') {

			var count      = 1;
			var moreToLoad = false;

			$('.hide-inventory-details-container').each(function() {

				if (count <= 10) {
					$(this).removeClass('hide-inventory-details-container');

					$parentContainer = $(this).closest('.js-inventory-availability-container');
					$parentContainer.find('.debug-inventory').removeClass('hide-debug-inventory');
				}
				else {
					moreToLoad = true;
					return false;
				}

				count++;
			});

			if (!moreToLoad) {
				$('.js-load-availability-controls').hide();
			}

			isTransitioning = false;
		}
		else if (type === 'reset') {
			$('.js-load-availability-controls').show();
		}
	};
});

// **************************************************************************************************************
// FUNCTION:    assembleInventoryResortFees
// PARAMETERS:  invMatchID
// DESCRIPTION: This function handles obtaining "Due At Resort" fee data for a specified
//              piece of inventory to display in a modal window
// **************************************************************************************************************
jQuery(function($) {

	function assembleInventoryResortFees(invMatchID) {

		$('body').addClass('loading-body-overlay');

		$.ajax({
			method: "POST",
			url: "/h/resort/AssembleInventoryResortFees",
			data: {invmatchid: invMatchID}
		})
			.done(function (data) {

				var dataJSON       = JSON.parse(data);
				var closeOnOverlay = true;
				var dialogMarkup   = '';

				if (dataJSON !== '') {

					dialogMarkup = dataJSON.modalHTML;

				} else {

					dialogMarkup = '<div>An unexpected error has occurred. Please try again.</div>';
				}

				$('body').removeClass('loading-body-overlay');
				launchInfoDialogWithClass(dialogMarkup, closeOnOverlay, 'l-dialog-inventory-resort-fees');

			});
	}

	$(document.body).on('click', '.js-resort-fees', function() {

		var invMatchID = $(this).data('inv-match-id');

		assembleInventoryResortFees(invMatchID);
	});

	function assembleInventoryLocalResortFees(invMatchID) {

		$('body').addClass('loading-body-overlay');

		$.ajax({
			method: "POST",
			url: "/h/resort/AssembleInventoryLocalResortFees",
			data: {invmatchid: invMatchID}
		})
			.done(function (data) {

				var dataJSON       = JSON.parse(data);
				var closeOnOverlay = true;
				var dialogMarkup   = '';

				if (dataJSON !== '') {

					dialogMarkup = dataJSON.modalHTML;

				} else {

					dialogMarkup = '<div>An unexpected error has occurred. Please try again.</div>';
				}

				$('body').removeClass('loading-body-overlay');
				launchInfoDialogWithClass(dialogMarkup, closeOnOverlay, 'l-dialog-inventory-resort-fees');

			});
	}


	$(document.body).on('click', '.js-local-fees', function() {

		var invMatchID = $(this).data('inv-match-id');

		assembleInventoryLocalResortFees(invMatchID);
	});

	function launchInfoDialogWithClass(message, closeOnOverlay, cssClass) {
		if (message) {
			lDialog.open({
				content: '<div class="ldialog-scroll-content">' + message + '</div>',
				closeOnOverlay: closeOnOverlay,
				className: cssClass
			});
		}
	}

});
